document.addEventListener('DOMContentLoaded', function () {
  const marqueeSliderTop = document.querySelector('.marquee-slider');
  const marqueeContainer = document.querySelector('[data-marquee-speed]');

  let speedTop = parseFloat(marqueeContainer.dataset.marqueeSpeed);
  let positionTop = 0;
  marqueeSliderTop.innerHTML;

  function scrollMarqueeTop() {
    positionTop -= speedTop;
    if (Math.abs(positionTop) >= marqueeSliderTop.scrollWidth / 2) {
      positionTop = 0;
    }
    marqueeSliderTop.style.transform = `translateX(${positionTop}px)`;
    requestAnimationFrame(scrollMarqueeTop);
  }

  scrollMarqueeTop();
  marqueeSliderTop.addEventListener('mouseover', () => (speedTop = 0.7));
  marqueeSliderTop.addEventListener('mouseout', () => (speedTop = parseFloat(marqueeContainer.dataset.marqueeSpeed)));
});